import React, { useState } from 'react';
import '../styles/AgentSelector.css';
import { sendData, trackEvent } from '../utils/api';
// Import React icons - only the ones we actually use
import { 
  AiFillThunderbolt,
  AiFillInstagram,
  AiFillYoutube,
  AiFillLinkedin,
  AiFillCalendar,
  AiFillMail,
  AiFillDashboard,
  AiFillMessage,
  AiFillAlert,
  AiFillShop,
  AiFillFileText,
  AiFillCustomerService,
  AiFillRobot
} from 'react-icons/ai';
import { FaTiktok, FaHandshake, FaHashtag, FaStar, FaFacebookF, FaTwitter, FaPinterest, FaWordpress, FaMailchimp } from 'react-icons/fa';
import { BiSupport, BiAnalyse, BiCalendarEvent } from 'react-icons/bi';
import { MdMeetingRoom, MdAnalytics, MdOutlineDesignServices, MdOutlineAttachMoney, MdWebAsset } from 'react-icons/md';
import { BsFillPeopleFill, BsMegaphone, BsGraphUp, BsBarChartFill, BsChat } from 'react-icons/bs';
import { SiMarketo, SiGoogleanalytics } from 'react-icons/si';
import { TbSeo } from 'react-icons/tb';
import { IoMdAnalytics } from 'react-icons/io';
import { GiArtificialIntelligence } from 'react-icons/gi';

const AgentSelector = ({ onContinue }) => {
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  
  // Get icon component with the appropriate brand color
  const getAgentIcon = (agentId) => {
    if (agentId.includes("instagram")) return <AiFillInstagram style={{color: '#E1306C'}} />;
    if (agentId.includes("youtube")) return <AiFillYoutube style={{color: '#FF0000'}} />;
    if (agentId.includes("tiktok")) return <FaTiktok style={{color: '#000000'}} />;
    if (agentId.includes("linkedin")) return <AiFillLinkedin style={{color: '#0077B5'}} />;
    if (agentId.includes("facebook")) return <FaFacebookF style={{color: '#1877F2'}} />;
    if (agentId.includes("twitter")) return <FaTwitter style={{color: '#1DA1F2'}} />;
    if (agentId.includes("pinterest")) return <FaPinterest style={{color: '#E60023'}} />;
    if (agentId.includes("email") || agentId.includes("mail")) return <AiFillMail style={{color: '#D44638'}} />;
    if (agentId.includes("calendar") || agentId.includes("schedul")) return <AiFillCalendar style={{color: '#0078D4'}} />;
    if (agentId.includes("affiliate") || agentId.includes("outreach")) return <FaHandshake style={{color: '#4CAF50'}} />;
    if (agentId.includes("analytics") || agentId.includes("report")) return <MdAnalytics style={{color: '#FF8C00'}} />;
    if (agentId.includes("dashboard")) return <AiFillDashboard style={{color: '#673AB7'}} />;
    if (agentId.includes("support") || agentId.includes("feedback")) return <BiSupport style={{color: '#2196F3'}} />;
    if (agentId.includes("product") || agentId.includes("ecommerce")) return <AiFillShop style={{color: '#FF5722'}} />;
    if (agentId.includes("meeting")) return <MdMeetingRoom style={{color: '#2196F3'}} />;
    if (agentId.includes("content") || agentId.includes("writer") || agentId.includes("blog")) return <AiFillFileText style={{color: '#00BCD4'}} />;
    if (agentId.includes("seo")) return <TbSeo style={{color: '#607D8B'}} />;
    if (agentId.includes("ad") || agentId.includes("campaign")) return <BsMegaphone style={{color: '#9C27B0'}} />;
    if (agentId.includes("hash")) return <FaHashtag style={{color: '#03A9F4'}} />;
    if (agentId.includes("review")) return <FaStar style={{color: '#FFC107'}} />;
    if (agentId.includes("podcast")) return <AiFillMessage style={{color: '#8BC34A'}} />;
    if (agentId.includes("visual") || agentId.includes("video") || agentId.includes("design")) return <MdOutlineDesignServices style={{color: '#FF9800'}} />;
    if (agentId.includes("lead") || agentId.includes("client")) return <BsFillPeopleFill style={{color: '#3F51B5'}} />;
    if (agentId.includes("competitor") || agentId.includes("crisis")) return <AiFillAlert style={{color: '#F44336'}} />;
    if (agentId.includes("customer")) return <AiFillCustomerService style={{color: '#009688'}} />;
    if (agentId.includes("engagement")) return <BsChat style={{color: '#795548'}} />;
    if (agentId.includes("performance")) return <BsGraphUp style={{color: '#4CAF50'}} />;
    if (agentId.includes("marketing")) return <SiMarketo style={{color: '#F44336'}} />;
    if (agentId.includes("event")) return <BiCalendarEvent style={{color: '#9C27B0'}} />;
    if (agentId.includes("growth")) return <BsBarChartFill style={{color: '#008000'}} />;
    if (agentId.includes("traffic")) return <SiGoogleanalytics style={{color: '#FF9800'}} />;
    if (agentId.includes("chatbot") || agentId.includes("bot")) return <GiArtificialIntelligence style={{color: '#607D8B'}} />;
    if (agentId.includes("website")) return <MdWebAsset style={{color: '#2196F3'}} />;
    if (agentId.includes("automation")) return <AiFillRobot style={{color: '#673AB7'}} />;
    if (agentId.includes("sentiment")) return <BiAnalyse style={{color: '#3F51B5'}} />;
    if (agentId.includes("wordpress")) return <FaWordpress style={{color: '#21759b'}} />;
    if (agentId.includes("mailchimp")) return <FaMailchimp style={{color: '#FFE01B'}} />;
    if (agentId.includes("commission")) return <MdOutlineAttachMoney style={{color: '#4CAF50'}} />;
    if (agentId.includes("retention")) return <IoMdAnalytics style={{color: '#3F51B5'}} />;
    // Default icon if no match
    return <AiFillThunderbolt style={{color: '#FFC107'}} />;
  };
  
  // Category mapping function
  const getCategoryFromAgentId = (agentId) => {
    if (agentId.includes("instagram") || agentId.includes("youtube") || agentId.includes("tiktok") || 
        agentId.includes("linkedin") || agentId.includes("social") || agentId.includes("facebook") ||
        agentId.includes("twitter") || agentId.includes("pinterest")) {
      return "Social Media";
    }
    if (agentId.includes("analytics") || agentId.includes("report") || 
        agentId.includes("data") || agentId.includes("dashboard")) {
      return "Analytics";
    }
    if (agentId.includes("content") || agentId.includes("blog") || agentId.includes("video") ||
        agentId.includes("podcast") || agentId.includes("writer")) {
      return "Content Creation";
    }
    if (agentId.includes("affiliate") || agentId.includes("marketing") || agentId.includes("campaign") ||
        agentId.includes("ad") || agentId.includes("outreach") || agentId.includes("seo")) {
      return "Marketing";
    }
    if (agentId.includes("client") || agentId.includes("crm") || agentId.includes("appointment") ||
        agentId.includes("customer") || agentId.includes("lead") || agentId.includes("meeting")) {
      return "Client Management";
    }
    if (agentId.includes("wellness") || agentId.includes("fitness") || agentId.includes("health")) {
      return "Wellness";
    }
    if (agentId.includes("calendar") || agentId.includes("schedul") || agentId.includes("time") ||
        agentId.includes("automat") || agentId.includes("reminder")) {
      return "Productivity";
    }
    if (agentId.includes("ecommerce") || agentId.includes("shop") || agentId.includes("product") ||
        agentId.includes("store") || agentId.includes("order")) {
      return "eCommerce";
    }
    // Default category if no match
    return "Other";
  };
  
  // Complete list of available AI agents - expanded to 50
  const DEFAULT_AGENTS = [
    {
      agentid: "instagram_post_scheduler",
      description: "Automates Instagram post scheduling, including captions, hashtags, and image/video uploads.",
      active_status: false
    },
    {
      agentid: "youtube_post_scheduler",
      description: "Schedules and manages YouTube video uploads, including video titles, descriptions, and tags.",
      active_status: false
    },
    {
      agentid: "tiktok_post_scheduler",
      description: "Schedules TikTok videos, including captions, hashtags, and music choices for consistent posting.",
      active_status: false
    },
    {
      agentid: "linkedin_post_scheduler",
      description: "Automates LinkedIn content posting, including professional updates, blog posts, and articles.",
      active_status: false
    },
    {
      agentid: "facebook_post_scheduler",
      description: "Schedules and manages Facebook posts, including text, images, videos and links.",
      active_status: false
    },
    {
      agentid: "twitter_post_scheduler",
      description: "Automates Twitter posts with optimal hashtags and engagement-focused content.",
      active_status: false
    },
    {
      agentid: "pinterest_pin_scheduler",
      description: "Creates and schedules Pinterest pins to drive traffic to your website or products.",
      active_status: false
    },
    {
      agentid: "instagram_comment_responder",
      description: "Automatically replies to comments on Instagram posts, engaging with followers and clients.",
      active_status: false
    },
    {
      agentid: "youtube_comment_responder",
      description: "Automatically replies to comments on YouTube videos, maintaining engagement with viewers.",
      active_status: false
    },
    {
      agentid: "tiktok_comment_responder",
      description: "Automatically replies to comments on TikTok videos, enhancing engagement and building a community.",
      active_status: false
    },
    {
      agentid: "linkedin_comment_responder",
      description: "Automatically replies to comments on LinkedIn posts to engage with your professional network.",
      active_status: false
    },
    {
      agentid: "facebook_comment_responder",
      description: "Manages responses to comments on Facebook posts to maintain high engagement levels.",
      active_status: false
    },
    {
      agentid: "instagram_dm_responder",
      description: "Handles direct message responses on Instagram, including answering common questions or engaging with leads.",
      active_status: false
    },
    {
      agentid: "youtube_dm_responder",
      description: "Manages direct messages on YouTube, responding to questions and fostering communication with subscribers.",
      active_status: false
    },
    {
      agentid: "tiktok_dm_responder",
      description: "Responds to direct messages on TikTok, keeping interactions with followers efficient and friendly.",
      active_status: false
    },
    {
      agentid: "linkedin_dm_responder",
      description: "Handles direct message responses on LinkedIn to keep professional communication smooth.",
      active_status: false
    },
    {
      agentid: "facebook_dm_responder",
      description: "Manages Facebook Messenger communications with automated responses to common queries.",
      active_status: false
    },
    {
      agentid: "calendar_appointment_manager",
      description: "Automates scheduling of client appointments, including reminders and calendar synchronization.",
      active_status: false
    },
    {
      agentid: "email_reply_manager",
      description: "Manages and responds to client emails with pre-configured templates or personalized replies.",
      active_status: false
    },
    {
      agentid: "email_newsletter_sender",
      description: "Schedules and sends out newsletters or promotional emails to a list of subscribers, tracking open rates and engagement.",
      active_status: false
    },
    {
      agentid: "affiliate_program_manager",
      description: "Manages and tracks affiliate marketing programs, including commissions, leads, and performance metrics.",
      active_status: false
    },
    {
      agentid: "social_media_engagement_reporter",
      description: "Generates reports on social media engagement metrics, such as likes, comments, shares, and follower growth.",
      active_status: false
    },
    {
      agentid: "instagram_story_scheduler",
      description: "Schedules Instagram stories, including multimedia content and links, based on engagement times.",
      active_status: false
    },
    {
      agentid: "youtube_video_analytics",
      description: "Tracks YouTube video performance, analyzing views, watch time, subscriber growth, and audience demographics.",
      active_status: false
    },
    {
      agentid: "tiktok_video_analytics",
      description: "Monitors TikTok video performance, including views, likes, comments, shares, and audience insights.",
      active_status: false
    },
    {
      agentid: "linkedin_article_analytics",
      description: "Analyzes engagement on LinkedIn articles, including views, likes, comments, and shares.",
      active_status: false
    },
    {
      agentid: "social_media_follower_growth_report",
      description: "Generates monthly reports on follower growth across Instagram, YouTube, TikTok, and LinkedIn.",
      active_status: false
    },
    {
      agentid: "website_traffic_reporter",
      description: "Generates detailed reports on website traffic, user behavior, and conversion rates to optimize your online presence.",
      active_status: false
    },
    {
      agentid: "social_media_engagement_bot",
      description: "Automates engagement on social media by liking, commenting, and following relevant users based on predefined criteria.",
      active_status: false
    },
    {
      agentid: "client_appointment_reminder",
      description: "Sends automated reminders to clients for upcoming appointments, reducing no-shows and improving time management.",
      active_status: false
    },
    {
      agentid: "affiliate_performance_reporter",
      description: "Generates detailed reports on affiliate marketing performance, including conversion rates and commissions earned.",
      active_status: false
    },
    {
      agentid: "comment_sentiment_analyzer",
      description: "Analyzes the sentiment of comments on social media posts, classifying them as positive, negative, or neutral.",
      active_status: false
    },
    {
      agentid: "social_media_ad_campaign_manager",
      description: "Creates, manages, and optimizes social media ad campaigns across platforms like Instagram, Facebook, and TikTok.",
      active_status: false
    },
    {
      agentid: "client_feedback_automation",
      description: "Automatically collects and analyzes client feedback after sessions to improve services and customer satisfaction.",
      active_status: false
    },
    {
      agentid: "meeting_scheduling_assistant",
      description: "Handles scheduling and rescheduling meetings, syncing with clients' calendars and sending confirmations.",
      active_status: false
    },
    {
      agentid: "client_engagement_reporter",
      description: "Tracks and generates reports on client engagement, including session attendance and follow-up responses.",
      active_status: false
    },
    {
      agentid: "online_booking_system_manager",
      description: "Automates the booking process for online consultations or appointments, syncing with calendar and payment systems.",
      active_status: false
    },
    {
      agentid: "video_content_creator",
      description: "Assists in creating engaging video content for YouTube, Instagram, TikTok, and LinkedIn, with automated editing and optimization.",
      active_status: false
    },
    {
      agentid: "client_retention_analytics",
      description: "Tracks client retention rates, identifying patterns and suggesting strategies to improve client loyalty.",
      active_status: false
    },
    {
      agentid: "collaboration_manager",
      description: "Helps manage collaborations with influencers, affiliates, and other wellness professionals, tracking interactions and agreements.",
      active_status: false
    },
    {
      agentid: "social_media_crisis_manager",
      description: "Monitors social media for potential PR crises, automating alerts and suggesting responses to negative comments or feedback.",
      active_status: false
    },
    {
      agentid: "referral_program_manager",
      description: "Manages and tracks referral programs, encouraging clients to refer new clients with rewards or incentives.",
      active_status: false
    },
    {
      agentid: "brand_ambassador_program_manager",
      description: "Tracks and manages brand ambassador programs, assigning tasks, monitoring performance, and reporting results.",
      active_status: false
    },
    {
      agentid: "social_media_content_calendar",
      description: "Organizes and manages a content calendar for social media posts across all platforms to ensure consistency and strategic posting.",
      active_status: false
    },
    {
      agentid: "live_stream_event_manager",
      description: "Automates the setup, promotion, and monitoring of live streaming events on platforms like Instagram, YouTube, and Facebook.",
      active_status: false
    },
    {
      agentid: "client_reminder_bot",
      description: "Sends reminders to clients for upcoming wellness sessions, payment deadlines, or important updates.",
      active_status: false
    },
    {
      agentid: "personal_branding_reporter",
      description: "Tracks and reports on the growth and health of your personal brand across all platforms.",
      active_status: false
    },
    {
      agentid: "client_outreach_automation",
      description: "Automates outreach to clients for feedback, appointments, special offers, or engagement opportunities.",
      active_status: false
    },
    {
      agentid: "content_performance_reporter",
      description: "Generates performance reports on blog posts, videos, and other content to identify what's working best.",
      active_status: false
    },
    {
      agentid: "time_management_assistant",
      description: "Assists in managing daily tasks, optimizing schedules, and reducing stress through efficient time management.",
      active_status: false
    },
    {
      agentid: "event_promotion_bot",
      description: "Automates the promotion of events (workshops, webinars, retreats) across social media platforms.",
      active_status: false
    },
    {
      agentid: "ecommerce_order_manager",
      description: "Manages orders and customer inquiries for wellness product sales on eCommerce platforms.",
      active_status: false
    }
  ];
  
  // Process the agents array to format it for our component
  const agents = DEFAULT_AGENTS.map((agent, index) => ({
    id: index + 1,
    name: agent.agentid.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
    category: getCategoryFromAgentId(agent.agentid),
    description: agent.description,
    agentid: agent.agentid,
    active_status: agent.active_status
  }));

  // Toggle agent selection
  const toggleAgent = (agentId) => {
    let updatedAgents;
    
    if (selectedAgents.includes(agentId)) {
      updatedAgents = selectedAgents.filter(id => id !== agentId);
      trackEvent('agent_deselected', { agentId });
    } else {
      updatedAgents = [...selectedAgents, agentId];
      trackEvent('agent_selected', { agentId });
    }
    
    setSelectedAgents(updatedAgents);
  };

  // Handle continue button click with data submission
  const handleContinue = async () => {
    const selectedAgentDetails = agents.filter(agent => selectedAgents.includes(agent.id));
    
    try {
      // Send selected agents data to API
      await sendData('/user-preferences/agents', {
        selectedAgents: selectedAgentDetails.map(agent => ({
          id: agent.id,
          name: agent.name,
          category: agent.category,
          agentid: agent.agentid
        })),
        interactionTime: new Date().toISOString()
      });
      
      // Track the continue action
      trackEvent('agent_selection_completed', {
        count: selectedAgents.length,
        categories: [...new Set(selectedAgentDetails.map(agent => agent.category))]
      });
      
      // Call the parent's onContinue handler
      onContinue(selectedAgentDetails);
    } catch (error) {
      console.error('Error saving agent preferences:', error);
      // Still continue the flow even if the API call fails
      onContinue(selectedAgentDetails);
    }
  };

  // Get unique categories from agents
  const categories = ['All', ...new Set(agents.map(agent => agent.category))];

  // Filter agents by search term and category
  const filteredAgents = agents.filter(agent => {
    const matchesSearch = agent.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         agent.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === 'All' || agent.category === activeCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <section className="agent-selector" id="agent-selector">
      <div className="container">
        <h2>Explore and <span className="highlight">Activate</span> Your AI Agents</h2>
        <p className="section-subtitle">
          Toggle to activate the AI agents you need most for your business
        </p>
        
        <div className="agent-controls">
          <div className="search-box">
            <input 
              type="text"
              placeholder="Search agents..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="search-icon">🔍</span>
          </div>
          
          <div className="selected-count">
            <span>{selectedAgents.length}</span> Agents Selected
          </div>
        </div>
        
        <div className="category-filter">
          {categories.map(category => (
            <button
              key={category}
              className={`category-button ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
        
        <div className="compact-agents-grid">
          {filteredAgents.map(agent => (
            <div 
              key={agent.id} 
              className={`compact-agent-card ${selectedAgents.includes(agent.id) ? 'active' : ''}`}
              onClick={() => toggleAgent(agent.id)}
              title={agent.description}
            >
              <div className="compact-toggle">
                <div className="toggle-indicator"></div>
              </div>
              <div className="agent-content">
                <div className="agent-header">
                  <div className="agent-icon">
                    {getAgentIcon(agent.agentid)}
                  </div>
                  <h4>{agent.name}</h4>
                </div>
                <div className="agent-meta">
                  <div className="meta-row">
                    <span className="agent-category">{agent.category}</span>
                    {selectedAgents.includes(agent.id) && (
                      <span className="active-badge">ACTIVE</span>
                    )}
                  </div>
                  <p className="agent-description">{agent.description.substring(0, 40)}...</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {filteredAgents.length === 0 && (
          <div className="no-results">
            <p>No agents found matching your search criteria.</p>
          </div>
        )}
        
        <div className="agent-selector-cta">
          <button 
            className="primary-button"
            onClick={handleContinue}
            disabled={selectedAgents.length === 0}
          >
            Continue with Selected Agents ({selectedAgents.length})
          </button>
          <p className="selection-note">You can always activate more agents later</p>
        </div>
      </div>
    </section>
  );
};

export default AgentSelector;
